import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const recipeAdminAdminAccessControl: DomainAccessControlConfig = {
  permissions: Permission.AdminPanel,
}
